<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="showCreate()" class="btn-in-line" type="primary" v-if="hasPermission">create client param</zm-button>
            <zm-button size="small" @click="fetchData()" type="primary" class="btn-in-line" plain>refresh</zm-button>
        </zm-row>
        <div class="table-container">
            <zm-table resizable border :data="list" v-loading="loading">
                <zm-table-column type="expand">
                    <template slot-scope="props">
                        <zm-form>
                            <zm-form-item v-for="(value, key, index) in props.row.parameters"
                                :key="index" :label="key" class="param-form-item">
                                {{ value }}
                            </zm-form-item>
                            <zm-form-item v-for="(value, key, index) in props.row.goParameters"
                                :key="index" :label="key" class="param-form-item">
                                {{ value }}
                            </zm-form-item>
                            <zm-form-item v-for="(value, key, index) in props.row.javaParameters"
                                :key="index" :label="key" class="param-form-item">
                                {{ value }}
                            </zm-form-item>
                        </zm-form>
                    </template>
                </zm-table-column>
                <zm-table-column prop="id" label="id"></zm-table-column>
                <zm-table-column prop="name" label="name"></zm-table-column>
                <zm-table-column prop="version" label="version"></zm-table-column>
                <zm-table-column prop="defaultParam" label="defaultParam" width="120px" align="center">
                    <template slot-scope='scope'>
                        <i class='glyphicon' :class="{'zm-icon-ok':scope.row.defaultParam,'zm-icon-close':!scope.row.defaultParam}"></i>
                    </template>
                </zm-table-column>
                <zm-table-column width="140px" v-if="hasPermission">
                    <template slot-scope="scope">
                        <zm-button size="small" type="icon" icon="zm-icon-edit" @click="showEdit(scope.row)"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-copy" @click="showDuplicate(scope.row)"></zm-button>
                        <zm-button size="small" type="icon" icon="zm-icon-delete" @click="showDelete(scope.row.id)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
        </div>
        <zm-dialog :title="form.title" :visible.sync="dialogFormVisible" append-to-body>
            <zm-form :model="form" :rules="rules" label-position="left" ref="form">
                <zm-form-item label="name" label-width="100px" prop="name">
                    <div slot="label">
                        <tip label="name" id="clientparam-name"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.name"></zm-input>
                </zm-form-item>
                <zm-table :data="form.parameters" max-height="300">
                    <zm-table-column prop="key" label="key">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.isEdit">{{ scope.row.key }}</span>
                            <zm-select size="small" v-model="scope.row.key" v-else filterable clearable allow-create>
                                <zm-option v-for="item in selectableKeys" :key="item.key"
                                    :disabled="!item.active" :value="item.key" :label="item.key"></zm-option>
                            </zm-select>
                        </template>
                    </zm-table-column>
                    <zm-table-column prop="type" label="type">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.isEdit">{{ scope.row.type }}</span>
                            <zm-select size="small" v-model="scope.row.type" v-else>
                                <zm-option value="java" label="java"></zm-option>
                                <zm-option value="go" label="go"></zm-option>
                                <zm-option value="universal" label="universal"></zm-option>
                            </zm-select>
                        </template>
                    </zm-table-column>
                    <zm-table-column prop="value" label="value">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.isEdit">{{ scope.row.value }}</span>
                            <zm-input size="small" v-model.trim="scope.row.value" v-else></zm-input>
                        </template>
                    </zm-table-column>
                    <zm-table-column width="100px">
                        <!-- eslint-disable-next-line -->
                        <template slot="header" slot-scope="scope">
                            <zm-button size="small" @click="addParam" type="icon" icon="zm-icon-add" :disabled="addDisabled">add parameter</zm-button>
                        </template>
                        <template slot-scope="scope">
                            <zm-button size="small" type="icon" icon="zm-icon-edit" @click="scope.row.isEdit = true" v-if="!scope.row.isEdit"></zm-button>
                            <zm-button size="small" type="icon" icon="zm-icon-ok" v-else
                                @click="scope.row.isEdit = false" :disabled="!scope.row.value.length || !scope.row.key.length"></zm-button>
                            <zm-button size="small" type="icon" icon="zm-icon-delete"
                                @click="deleteParam(scope.row.key)"></zm-button>
                        </template>
                    </zm-table-column>
                </zm-table>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="dialogFormVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import {
    createClient,
    updateClient,
    duplicateClient,
    listClient,
    getDefault,
    getKeys,
    deleteClient
} from '../../api/clientparam'
import tip from 'components/ToolTip/index'
export default {
    components: { tip },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            list: [],
            defaultParam: {},
            keys: [],
            loading: false,
            form: {
                title: '',
                id: '',
                name: '',
                clientType: '',
                parameters: []
            },
            dialogFormVisible: false,
            showAddParam: false,
            formLabelWidth: '250px',
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ]
            }
        }
    },
    props: ['type'],
    created () {
        this.fetchData()
        this.fetchDefault()
        this.fetchKey()
        this.form.clientType = this.type
    },
    computed: {
        selectableKeys () {
            let data = this.keys
            this.keys.map(key => {
                key.active = true
                this.form.parameters.map(item => {
                    if (key.key === item.key) {
                        key.active = false
                    }
                })
            })
            return data
        },
        addDisabled () {
            let data = false
            this.form.parameters.map(item => {
                if (item.isEdit) {
                    data = true
                }
            })
            return data
        }
    },
    methods: {
        fetchData () {
            this.loading = true
            listClient(this.type).then(response => {
                this.list = response
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        fetchDefault () {
            this.loading = true
            getDefault(this.type).then(response => {
                this.defaultParam = response.defaultConfig
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        fetchKey () {
            this.loading = true
            getKeys(this.type).then(response => {
                // this.keys = response.paramKeys
                response.paramKeys.map(key => {
                    this.keys.push({
                        key: key,
                        active: true
                    })
                })
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        showCreate () {
            this.form.title = 'Add Client'
            this.form.id = ''
            this.form.name = ''
            this.form.parameters = []
            for (let key in this.defaultParam) {
                this.form.parameters.push({
                    key: key,
                    type: 'universal',
                    value: this.defaultParam[key] || this.defaultParam[key] === 0 || this.defaultParam[key] === false ? this.defaultParam[key].toString() : '',
                    isEdit: false
                })
            }
            this.dialogFormVisible = true
        },
        showEdit (row) {
            this.form.title = 'Edit Client'
            this.form.id = row.id
            this.form.name = row.name
            this.form.parameters = []
            for (let key in row.parameters) {
                this.form.parameters.push({
                    key: key,
                    type: 'universal',
                    value: row.parameters[key] || row.parameters[key] === 0 || this.defaultParam[key] === false ? row.parameters[key].toString() : '',
                    isEdit: false
                })
            }
            for (let key in row.goParameters) {
                this.form.parameters.push({
                    key: key,
                    type: 'go',
                    value: row.goParameters[key] || row.goParameters[key] === 0 || this.defaultParam[key] === false ? row.goParameters[key].toString() : '',
                    isEdit: false
                })
            }
            for (let key in row.javaParameters) {
                this.form.parameters.push({
                    key: key,
                    type: 'java',
                    value: row.javaParameters[key] || row.javaParameters[key] === 0 || this.defaultParam[key] === false ? row.javaParameters[key].toString() : '',
                    isEdit: false
                })
            }
            this.dialogFormVisible = true
        },
        showDuplicate (row) {
            this.form.title = 'Duplicate Client'
            this.form.id = ''
            this.form.name = ''
            this.form.parameters = []
            for (let key in row.parameters) {
                this.form.parameters.push({
                    key: key,
                    type: 'universal',
                    value: row.parameters[key] || row.parameters[key] === 0 || this.defaultParam[key] === false ? row.parameters[key].toString() : '',
                    isEdit: false
                })
            }
            for (let key in row.goParameters) {
                this.form.parameters.push({
                    key: key,
                    type: 'go',
                    value: row.goParameters[key] || row.goParameters[key] === 0 || this.defaultParam[key] === false ? row.goParameters[key].toString() : '',
                    isEdit: false
                })
            }
            for (let key in row.javaParameters) {
                this.form.parameters.push({
                    key: key,
                    type: 'java',
                    value: row.javaParameters[key] || row.javaParameters[key] === 0 || this.defaultParam[key] === false ? row.javaParameters[key].toString() : '',
                    isEdit: false
                })
            }
            this.dialogFormVisible = true
        },
        deleteParam (key) {
            if (key) {
                this.form.parameters.map((item, index, arr) => {
                    if (item.key === key) {
                        this.form.parameters.splice(index, 1)
                    }
                })
            } else {
                this.form.parameters.shift()
            }
        },
        showDelete (id) {
            this.$confirm('This will delete the client parameter. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteClient(id).then(response => {
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                    this.fetchData()
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        addParam () {
            this.form.parameters.unshift({
                key: '',
                type: 'universal',
                value: '',
                isEdit: true
            })
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    const { id, title, clientType, name } = this.form
                    var parameters = {}
                    var goParameters = {}
                    var javaParameters = {}
                    this.form.parameters.map(item => {
                        if (item.value !== '' && item.type !== '') {
                            if (item.type === 'universal') {
                                parameters[item.key] = item.value
                            } else if (item.type === 'go') {
                                goParameters[item.key] = item.value
                            } else if (item.type === 'java') {
                                javaParameters[item.key] = item.value
                            }
                        }
                    })
                    const data = { clientType, name, parameters, goParameters, javaParameters }
                    if (title === 'Add Client') {
                        createClient(data).then(response => {
                            this.dialogFormVisible = false
                            this.$message({
                                type: 'success',
                                message: 'Create success'
                            })
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (title === 'Edit Client') {
                        updateClient(id, data).then(response => {
                            this.dialogFormVisible = false
                            this.$message({
                                type: 'success',
                                message: 'Edit success'
                            })
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else if (title === 'Duplicate Client') {
                        duplicateClient(data).then(response => {
                            this.dialogFormVisible = false
                            this.$message({
                                type: 'success',
                                message: 'Duplicate success'
                            })
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: 'Invalid submit!'
                    })
                }
            })
        }
    }
}
</script>
<style scoped>
.form-input {
    width: calc(100% - 30px);
}
.param-form-item {
    margin: 0;
}
.btn-in-line{
    margin: 10px;
}
</style>
